module.exports = __webpack_public_path__ + "img/63efd94.jpg";